import React from "react";
import LegalLayout from "@/components/site/LegalLayout";
import { COMPANY } from "@/lib/i18n";

const sections = [
  {
    h: { ro: "1. Ce sunt cookie-urile", en: "1. What are cookies" },
    p: [
      {
        ro: "Cookie-urile sunt fișiere de mici dimensiuni, formate din litere și numere, care sunt stocate pe computerul, terminalul mobil sau alt echipament al unui utilizator de pe care se accesează internetul. Cookie-ul este instalat prin solicitarea emisă de un web-server către un browser și este complet „pasiv” (nu conține programe software, viruși sau spyware și nu poate accesa informații de pe hard disk-ul utilizatorului).",
        en: "Cookies are small files, made up of letters and numbers, that are stored on the computer, mobile terminal or other equipment of a user from which the internet is accessed. A cookie is installed through a request issued by a web server to a browser and is completely \"passive\" (it does not contain software programs, viruses or spyware and cannot access information on the user's hard drive).",
      },
    ],
  },
  {
    h: { ro: "2. Cum folosim cookie-urile", en: "2. How we use cookies" },
    p: [
      {
        ro: `Site-ul ${COMPANY.name} folosește cookie-uri proprii și, opțional, de la terți pentru a asigura funcționarea corectă a paginii, a reține preferințele tale (precum limba selectată) și pentru a înțelege modul în care vizitatorii interacționează cu conținutul nostru, în scopul îmbunătățirii continue a experienței oferite.`,
        en: `The ${COMPANY.name} website uses its own cookies and, optionally, third-party cookies to ensure the correct functioning of the page, to remember your preferences (such as the selected language), and to understand how visitors interact with our content, in order to continuously improve the experience we provide.`,
      },
    ],
  },
  {
    h: { ro: "3. Tipuri de cookie-uri utilizate", en: "3. Types of cookies used" },
    p: [
      {
        ro: "În funcție de durata lor de viață, cookie-urile pot fi de sesiune (temporare, sunt șterse automat când browserul este închis) sau persistente (rămân stocate pe dispozitiv o perioadă determinată, definită prin data de expirare).",
        en: "Depending on their lifespan, cookies can be session cookies (temporary, automatically deleted when the browser is closed) or persistent cookies (remain stored on the device for a set period, defined by the expiration date).",
      },
    ],
    list: [
      { ro: "Cookie-uri strict necesare — esențiale pentru funcționarea corectă a site-ului (ex. reținerea limbii selectate, meniul de navigare).", en: "Strictly necessary cookies — essential for the correct functioning of the website (e.g. remembering the selected language, the navigation menu)." },
      { ro: "Cookie-uri de performanță — colectează informații anonime despre modul în care este utilizat site-ul, pentru a ne ajuta să identificăm și să remediem eventuale probleme.", en: "Performance cookies — collect anonymous information about how the site is used, helping us identify and fix any issues." },
      { ro: "Cookie-uri de funcționalitate — permit site-ului să rețină alegerile pe care le faci (precum numele de utilizator sau regiunea) pentru o experiență personalizată.", en: "Functionality cookies — allow the website to remember the choices you make (such as username or region) for a personalized experience." },
    ],
  },
  {
    h: { ro: "4. Cookie-uri terțe", en: "4. Third-party cookies" },
    p: [
      {
        ro: "Anumite secțiuni de conținut de pe site pot fi furnizate prin intermediul unor terți (de exemplu, hărți interactive sau fonturi web), care pot instala propriile cookie-uri. Nu avem control direct asupra informațiilor colectate de aceste cookie-uri terțe și te încurajăm să consulți politicile de confidențialitate ale furnizorilor respectivi.",
        en: "Certain content sections on the site may be provided through third parties (for example, interactive maps or web fonts), which may install their own cookies. We do not have direct control over the information collected by these third-party cookies, and we encourage you to check the privacy policies of those providers.",
      },
    ],
  },
  {
    h: { ro: "5. Cum poți controla cookie-urile", en: "5. How you can control cookies" },
    p: [
      {
        ro: "Poți controla și/sau șterge cookie-urile după cum dorești. Poți șterge toate cookie-urile deja existente pe calculatorul tău, iar majoritatea browserelor pot fi setate pentru a preveni stocarea acestora. Dacă alegi să faci acest lucru, este posibil ca anumite secțiuni ale site-ului să nu funcționeze corespunzător.",
        en: "You can control and/or delete cookies as you wish. You can delete all cookies already on your computer, and most browsers can be set to prevent them from being stored. If you choose to do this, some sections of the site may not function properly.",
      },
    ],
  },
  {
    h: { ro: "6. Contact", en: "6. Contact" },
    p: [
      {
        ro: `Pentru orice întrebări legate de utilizarea cookie-urilor pe acest site, ne poți contacta la ${COMPANY.email} sau la numărul de telefon ${COMPANY.phone}.`,
        en: `For any questions regarding the use of cookies on this site, you can contact us at ${COMPANY.email} or at phone number ${COMPANY.phone}.`,
      },
    ],
  },
];

export default function CookiePolicy() {
  return (
    <LegalLayout
      label={{ ro: "Legal", en: "Legal" }}
      title={{ ro: "Politica de cookies", en: "Cookie policy" }}
      updated="22.07.2026"
      sections={sections}
    />
  );
}
